import React from 'react';
import { Paper } from '@mui/material';
import { customerEmptyStatePaperSx, customerSectionPaperSx } from '../../constants/customerTheme';

const VARIANT_STYLES = {
  default: customerSectionPaperSx,
  empty: customerEmptyStatePaperSx,
};

const CustomerPageSection = ({ children, variant = 'default', sx, ...paperProps }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2.5, sm: 3 },
      ...VARIANT_STYLES[variant],
      ...sx,
    }}
    {...paperProps}
  >
    {children}
  </Paper>
);

export default CustomerPageSection;
